import React, { useState } from 'react';
import { 
  FaTablet, 
  FaEnvelope, 
  FaArrowLeft, 
  FaCog, 
  FaTools,
  FaKey
} from 'react-icons/fa';
import ApiComponent from './ApiComponent';
import SMTP from './SMTP';
import APIWorkspace from './APIWorkspace';
import styles from '../CSS/Management.module.css';

const Management = () => {
  const [activeView, setActiveView] = useState('main');

  const renderMainView = () => (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderContent}>
          <FaTools className={`${styles.pageHeaderIcon} ${styles.iconManagement}`} />
          <div>
            <h1>Gestión del Sistema</h1>
            <p>Panel de herramientas administrativas</p>
          </div>
        </div>
      </div>

      <div className={styles.pageContent}>
        <div className={styles.toolsGrid}>
          <div 
            className={styles.toolCard}
            onClick={() => setActiveView('ipads')}
          >
            <div className={styles.toolIcon}>
              <FaTablet />
            </div>
            <div className={styles.toolContent}>
              <h3>iPads</h3>
              <p>Gestión y administración de dispositivos iPad</p>
              <span className={styles.toolBadge}>Disponible</span>
            </div>
          </div>

          <div 
            className={`${styles.toolCard} ${styles.smtp}`}
            onClick={() => setActiveView('smtp')}
          >
            <div className={styles.toolIcon}>
              <FaEnvelope />
            </div>
            <div className={styles.toolContent}>
              <h3>SMTP</h3>
              <p>Configuración del servidor de correo electrónico</p>
              <span className={styles.toolBadge}>Disponible</span>
            </div>
          </div>

          <div 
            className={`${styles.toolCard} ${styles.apiWorkspace}`}
            onClick={() => setActiveView('apiworkspace')}
          >
            <div className={styles.toolIcon}>
              <FaKey />
            </div>
            <div className={styles.toolContent}>
              <h3>API Workspace</h3>
              <p>Gestión segura de claves de Google Workspace APIs</p>
              <span className={styles.toolBadge}>Disponible</span>
            </div>
          </div>

          <div className={`${styles.toolCard} ${styles.placeholder}`}>
            <div className={styles.toolIcon}>
              <FaCog />
            </div>
            <div className={styles.toolContent}>
              <h3>Más herramientas</h3>
              <p>Próximas funcionalidades administrativas</p>
              <span className={styles.toolBadge}>En desarrollo</span>
            </div>
          </div>
        </div>

        <div className={styles.infoCard}>
          <h4>Información del Sistema</h4>
          <p>Panel centralizado para la gestión de herramientas administrativas del centro educativo.</p>
          <ul>
            <li>Gestión de dispositivos iPad</li>
            <li>Configuración de servicios de correo</li>
            <li>Gestión segura de APIs de Google Workspace</li>
            <li>Herramientas de administración</li>
          </ul>
        </div>
      </div>
    </>
  );

  const renderIPadsView = () => (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderContent}>
          <button 
            className={styles.backButton}
            onClick={() => setActiveView('main')}
          >
            <FaArrowLeft />
            <span>Volver</span>
          </button>
          <div className={styles.headerDivider}></div>
          <FaTablet className={`${styles.pageHeaderIcon} ${styles.iconIpads}`} />
          <div>
            <h1>Gestión de iPads</h1>
            <p>Administración y control de dispositivos</p>
          </div>
        </div>
      </div>
      <div className={styles.pageContent}>
        <ApiComponent />
      </div>
    </>
  );

  const renderSMTPView = () => (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderContent}>
          <button 
            className={styles.backButton}
            onClick={() => setActiveView('main')}
          >
            <FaArrowLeft />
            <span>Volver</span>
          </button>
          <div className={styles.headerDivider}></div>
          <FaEnvelope className={`${styles.pageHeaderIcon} ${styles.iconSmtp}`} />
          <div>
            <h1>Configuración SMTP</h1>
            <p>Servidor de correo electrónico</p>
          </div>
        </div>
      </div>
      <div className={styles.pageContent}>
        <SMTP />
      </div>
    </>
  );

  const renderAPIWorkspaceView = () => (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderContent}>
          <button 
            className={styles.backButton}
            onClick={() => setActiveView('main')}
          >
            <FaArrowLeft />
            <span>Volver</span>
          </button>
          <div className={styles.headerDivider}></div>
          <FaKey className={`${styles.pageHeaderIcon} ${styles.iconApiWorkspace}`} />
          <div>
            <h1>API Workspace</h1>
            <p>Gestión de claves de Google Workspace</p>
          </div>
        </div>
      </div>
      <div className={styles.pageContent}>
        <APIWorkspace />
      </div>
    </>
  );

  const renderContent = () => {
    switch (activeView) {
      case 'ipads':
        return renderIPadsView();
      case 'smtp':
        return renderSMTPView();
      case 'apiworkspace':
        return renderAPIWorkspaceView();
      case 'main':
      default:
        return renderMainView();
    }
  };

  return (
    <div className={styles.managementWrapper}>
      {renderContent()}
    </div>
  );
};

export default Management;